import { LoopscalePointsAction, ExternalPointReward, LendingVaultExpanded, LoopExpanded } from "@bridgesplit/abf-react";
import { TokenListMetadata } from "@bridgesplit/abf-sdk";
import { TextColor, TextVariant } from "@bridgesplit/ui";
export type GenericRewardsApyProps = {
    apy: number | undefined;
    loopscalePointsAction: LoopscalePointsAction;
    metadata: TokenListMetadata | undefined;
    externalPointRewards?: ExternalPointReward[];
    rateDisplayTextVariant?: TextVariant;
    rateDisplayColor?: TextColor;
};

export type RewardsLendVaultApyProps = GenericRewardsApyProps & {
    /** Used to control the rate display width only for featured & mobile */
    isFeatured: boolean;
    lendingVaultExpanded: LendingVaultExpanded | undefined;
    reverse?: boolean;
};

export type RewardsLendApyProps = GenericRewardsApyProps & {
    /** Used to control the rate display width only for featured & mobile */
    collateralYield: number | undefined;
    netApy: number | undefined;
    isFeatured: boolean;
};

export type RewardsBorrowApyProps = Omit<GenericRewardsApyProps, "externalPointRewards"> & {
    collateralYield: number | undefined;
    netApy: number | undefined;
};

export type RewardsLoopsApyProps = GenericRewardsApyProps & {
    /** Used to show max leverage based on loops */
    maxLeverage: number;
    /** Used to control the rate display width only for featured loops & mobile */
    isFeatured: boolean;
    /** Used for calculating principal borrowed with leverage to accuratley display max leverage points based on quotes */
    loopExpanded: LoopExpanded | undefined;
    collateralMetadata: TokenListMetadata | undefined;
};

export type RewardsPortfolioBorrowApyProps = GenericRewardsApyProps & {
    customDailyPoints: number | undefined;
    lendingVaultExpanded?: LendingVaultExpanded | undefined;
};

/**
 * This is a constant value that is used to calculate the principal borrowed with leverage.
 * It is used to accuratley display max leverage points based on quotes.
 * It can be changed to any value, but should be consistent with how much $ per point is used in the UI.
 */
export const POINT_BASIS = 1000;
